module.exports = __webpack_public_path__ + "32d2ec99e843df422670924f3c44edc3.png";